import setting_locals from "../../localization/localization_en_setting.json"

export const settings = {
    [Object.keys(setting_locals.settings.tabs)[0]]:setting_locals.settings.tabs["Account Settings"]
}